import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-body-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, index) => {
        return (_openBlock(), _createElementBlock("th", {
          key: index,
          class: _normalizeClass({ 'text-end': index + 1 === _ctx.columns.length })
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1)
        ], 2))
      }), 128))
    ])
  ]))
}